let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bMoVF")).then(() => parcelRequire('fUxGw'));